import { USER_ACC_SEARCHABLEITEMS, allItems } from './arsweb/RoutingPaths';
import { BackendService } from './BackendService';

const SEARCHABLE_ITEMS = "SEARCHABLEITEMS";

export class SearchableItemService {

    constructor(userService) {
        this.userService = userService;
        this.backendService = new BackendService(userService, USER_ACC_SEARCHABLEITEMS);
    }

    getSearchableItems($scope, refresh) {
        this.user = this.userService.fsMainDependencies.$rootScope.user;
        const key = SEARCHABLE_ITEMS + '/' + this.user.data.clientId; // ARSWEB-534 searchable items dependent on client id

        const storedSearchables = sessionStorage.getItem(key);
        if (storedSearchables === 'undefined' || storedSearchables === null || refresh) {
            return this.backendService.getUserData(allItems).then(data => {
                $scope.searchableItems = data;
                sessionStorage.setItem(key, JSON.stringify(data));
            });
        } else {
            return Promise.resolve($scope.searchableItems = JSON.parse(storedSearchables));
        }
    }

    readKindItems(kinds){
        this.backendService.service.config.params.kinds = kinds;
        return this.backendService.getUserData(allItems);
    }
}
